import API from "./api";
import secureLocalStorage from "react-secure-storage";

const user = JSON.parse(secureLocalStorage.getItem("profile"));

const check2 = user
  ? `?status[eq]=pending&location[eq]=${user.results.branch}`
  : "";
const branch = user?.results?.branch;
export const fetchLocations = () => API.get("/api/v1/company-location");

// sign in a new user
export const signIn = (formData) => API.post("/api/v1/users/login", formData);
// the user already signed in to another app, if any (shared login cookie)
export const fetchSignedInUser = () => API.get("/api/v1/users/me");
// ends the shared login for every app in this browser
export const signOut = () => API.post("/api/v1/users/logout");
// Sign up a new user
export const signup = (formData) => API.post("/api/v1/users/signup", formData);

// Security
// forgot password
export const forgotPassword = (postData) =>
  API.post("/api/v1/users/forgotPassword", postData);

// reset password
export const resetPassword = (token, postData) =>
  API.patch(`/api/v1/users/resetPassword/${token}`, postData);

// reset password
export const changePassword = (postData) =>
  API.patch(`/api/v1/users/updateMypassword`, postData);
export const getUsers = () => API.get("/api/v1/users");

// ! Update users information and delete users
export const updateUser = (id, postData) =>
  API.patch(`/api/v1/users/update-user/info/${id}`, postData);
export const deleteUser = (id) =>
  API.delete(`/api/v1/users/delete-selected-user/info/${id}`);

// STOCK
export const getStock = () => API.get("/api/v1/stock");

// issue from the main store to a location
export const issueStock = (item, quantity, location) =>
  API.post("/api/v1/stock/issue", { item, quantity, location });
// take an issue back into the main store
export const reverseIssue = (id) => API.post(`/api/v1/stock/issues/${id}/reverse`);
// undo a delivery into the main store
export const reverseStockReceipt = (id) =>
  API.post(`/api/v1/stock/receipts/${id}/reverse`);

// stock items

export const getStockItems = () => API.get("/api/v1/stock-item");
export const createStockItems = (postData) =>
  API.post("/api/v1/stock-item", postData);

export const deleteStockItem = (id) => API.delete(`/api/v1/stock-item/${id}`);
export const updateStockItem = (id, postData) =>
  API.patch(`/api/v1/stock-item/${id}`, postData);

// Receipts
// main-store issues (not undone ones, not branches' own purchases)
export const getReceipt = () =>
  API.get(`/api/v1/stock-receipt?status[nin]=reversed,branch%20purchase`);

// history
export const getStockHistoryDefault = () =>
  API.get("/api/v1/stock-history/stock-history-default");
export const getStockHistoryWithDate = (end) =>
  API.get(`/api/v1/stock-history/stock-history/${end}`);

// location
export const createLocation = (postData) =>
  API.post("/api/v1/stock-location", postData);
export const getStockLocation = () => API.get("/api/v1/stock-location");

export const deleteStockLocation = (id) =>
  API.delete(`/api/v1/stock-location/${id}`);

// Request
// this branch's requests from the last 90 days, whatever happened to them
export const getRequest = () =>
  API.get("/api/v1/stock-request", {
    params: {
      "location[eq]": branch,
      "date[gte]": new Date(Date.now() - 90 * 24 * 3600 * 1000).toISOString(),
    },
  });
export const createRequest = (postData) =>
  API.post(`/api/v1/stock-request`, postData);
export const deleteRequest = (id) => API.delete(`/api/v1/stock-request/${id}`);
export const updateRequest = (id, postData) =>
  API.patch(`/api/v1/stock-request/${id}`, postData);

// issue a branch request (stock moves and the request closes together)
export const issueRequest = (id, quantity) =>
  API.post(`/api/v1/stock-request/${id}/issue`, { quantity });

// Main store requisitions: raised, approved by a supervisor, then received
export const getRequisitions = () => API.get("/api/v1/stock-requisition");
export const createRequisition = (postData) =>
  API.post("/api/v1/stock-requisition", postData);
export const approveRequisition = (id) =>
  API.post(`/api/v1/stock-requisition/${id}/approve`);
export const declineRequisition = (id, reason) =>
  API.post(`/api/v1/stock-requisition/${id}/decline`, { reason });
export const cancelRequisition = (id) =>
  API.post(`/api/v1/stock-requisition/${id}/cancel`);
export const receiveRequisitionLine = (id, lineId, postData) =>
  API.post(`/api/v1/stock-requisition/${id}/lines/${lineId}/receive`, postData);

export const getLocationsRequest = () =>
  API.get("/api/v1/stock-request/request/incoming");

export const locationReceived = () => API.get(`/api/v1/stock-receipt${check2}`);
export const updateReceipt = (id, postData) =>
  API.patch(`/api/v1/stock-receipt/${id}`, postData);

// ! location stock information

export const locationCreateStock = (postData) =>
  API.post("/api/v1/location-stock", postData);

// a branch using its stock, and putting a usage back
export const consumeLocationStock = (item, quantity, location) =>
  API.post("/api/v1/location-stock/use", { item, quantity, location });
export const reverseLocationUsage = (id) =>
  API.post(`/api/v1/location-stock/usage/${id}/reverse`);

export const getLocationStock = () =>
  API.get(`/api/v1/location-stock?location[eq]=${branch}`);

export const locationReceipts = () =>
  API.get(`/api/v1/location-stock-receipts?status[ne]=reversed&location[eq]=${branch}`);

export const locationItems = () =>
  API.get(`/api/v1/location-stock-item?location[eq]=${branch}`);

// one item's record at every branch (head office)
export const getBranchItems = (item) =>
  API.get("/api/v1/location-stock-item", { params: { item } });

export const updateLocationItem = (id, postData) =>
  API.patch(`/api/v1/location-stock-item/${id}`, postData);
export const deleteLocationItem = (id) =>
  API.delete(`/api/v1/location-stock-item/${id}`);

export const getLocationDefaultStockHistory = () =>
  API.get(`/api/v1/location-stock-history/stock-history-default/${branch}`);

export const getSingleLocationReceipt = () =>
  API.get(`/api/v1/stock-receipt?status[ne]=reversed&location[eq]=${branch}`);

// deliveries into the main store
export const getStockReceived = () =>
  API.get(`/api/v1/stock-received?status[nin]=reversed,branch%20purchase`);

export const updateLocation = (id, postData) =>
  API.patch(`/api/v1/stock-location/${id}`, postData);

// -------------------------------/forecast/------------------------

export const admin_stock_received_yearly_cost = () =>
  API.get("/api/v1/stock-received/year-cost");
export const location_stock_received_yearly_cost = () =>
  API.get(`/api/v1/stock-receipt/stats/yearly/${branch}`);

export const admin_stock_issued_yearly_quantity = () =>
  API.get("/api/v1/stock-receipt/stats/yearly");
export const admin_stock_issued_monthly_quantity = () =>
  API.get("/api/v1/stock-receipt/stats/monthly");

export const location_stock_issued_monthly_quantity = () =>
  API.get(`/api/v1/location-stock-receipts/stats/monthly/${branch}`);
export const location_stock_issued_yearly_quantity = () =>
  API.get(`/api/v1/location-stock-receipts/stats/yearly/usage/${branch}`);

export const forecast_data = () =>
  API.get("/api/v1/stock-receipt/stats/monthly");

export const fetchCurrentPrices = () =>
  API.get("/api/v1/stock-received/current-unit-price");

// Authenticator-app sign-in: the code step after a correct password
export const twoFactorLoginVerify = (postData) =>
  API.post("/api/v1/users/two-factor/login/verify", postData);
export const twoFactorLoginSetup = (postData) =>
  API.post("/api/v1/users/two-factor/login/setup", postData);
export const twoFactorLoginSetupConfirm = (postData) =>
  API.post("/api/v1/users/two-factor/login/setup/confirm", postData);
// ...and the signed-in user's own authenticator app
export const getMyTwoFactor = () => API.get("/api/v1/users/two-factor/me");
export const startMyTwoFactorSetup = () =>
  API.post("/api/v1/users/two-factor/me/setup");
export const enableMyTwoFactor = (code) =>
  API.post("/api/v1/users/two-factor/me/enable", { code });
export const disableMyTwoFactor = (postData) =>
  API.post("/api/v1/users/two-factor/me/disable", postData);
export const newMyBackupCodes = (code) =>
  API.post("/api/v1/users/two-factor/me/backup-codes", { code });
